function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 100,
  height: 100,
  viewBox: "0 0 100 100",
  role: "img"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "m58.095 28.67-1.15-6.304a2 2 0 0 1 3.104-2.005l18.761 12.94a1 1 0 0 1 0 1.647L60.037 47.896a2 2 0 0 1-3.104-2.001l1.212-6.725H35.5a5 5 0 0 0-5 5v35.5H20v-40.5c0-5.8 4.701-10.5 10.5-10.5z"
}));
export default "/Users/mgomezlucero/Work/SkedGo/Projects/tripkit-react/src/images/directions/ic-turn-right.svg";
export { SvgComponent as ReactComponent };